"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[98590],{

/***/ 576862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FlashSaleFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FlashSaleFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.27655 5.41169C9.37245 4.86779 9.89111 4.50462 10.435 4.60053L16.5319 5.67558C16.898 5.74012 17.0681 6.16732 16.8467 6.46585L13.3551 11.1733C13.2222 11.3524 13.3243 11.6087 13.544 11.6475L15.36 11.9677C15.74 12.0347 15.9041 12.4887 15.6548 12.7832L9.75245 19.7537C9.55456 19.9874 9.17488 19.8093 9.22806 19.5077L10.1988 14.0023C10.2468 13.7304 10.0652 13.4711 9.79323 13.4231L8.9069 13.2668C8.363 13.1709 7.99984 12.6523 8.09574 12.1084L9.27655 5.41169Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 551165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Article; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(797864);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(666913);



const StyledCard = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Z)`
  .card-body {
    padding: 1rem;
  }
`;
const Article = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ content, title }, ref) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
    ref,
    header: title
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .HtmlRenderer */ .V, {
    content
  }));
});
Article.displayName = "Article";




/***/ }),

/***/ 962836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ FlashSaleBadge; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(334751);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/FlashSaleBadge/assets/flash-sale-background.es.js
var background = "https://shopfront-cdn.tekoapis.com/static/242be5f20fc8b658.svg";



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/FlashSaleFilled.es.js
var FlashSaleFilled_es = __webpack_require__(576862);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/CountdownText/CountdownText.es.js
var CountdownText_es = __webpack_require__(942541);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ClockAlternativeOutlined.es.js
var ClockAlternativeOutlined_es = __webpack_require__(753954);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/FlashSaleBadgeTime/FlashSaleBadgeTime.es.js




const TimeMessageWrapper = styled_es/* styled.div */.z.div`
  color: white;
  text-transform: initial;
  font-weight: normal;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const BoldWrapper = styled_es/* styled.span */.z.span`
  font-weight: bold;
`;
const LargeTextWrapper = styled_es/* styled.span */.z.span`
  margin-right: 4px;
`;
const StyledClockOutline = (0,styled_es/* styled */.z)(ClockAlternativeOutlined_es/* ClockAlternativeOutlined */.I)`
  margin-bottom: 2px;
`;
const FlashSaleBadgeTime = ({ size, endAt }) => {
  return /* @__PURE__ */ react.createElement(TimeMessageWrapper, null, size == "lg" && /* @__PURE__ */ react.createElement(LargeTextWrapper, null, /* @__PURE__ */ react.createElement(StyledClockOutline, {
    color: "#ffffff",
    size: 20
  })), /* @__PURE__ */ react.createElement(BoldWrapper, null, /* @__PURE__ */ react.createElement(CountdownText_es/* CountdownText */.c, {
    date: endAt
  })));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/FlashSaleBadge/FlashSaleBadge.es.js







const Wrapper = styled_es/* styled.div */.z.div((props) => {
  const styles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: `${props.backgroundColor || "red"}`,
    backgroundImage: `url("${background}"), ${!props.backgroundColor && (props.backgroundLinearGradient || "linear-gradient(275deg, #ff8949, #eb2101)")}`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    overflow: "hidden",
    borderRadius: "2.5rem!important"
  };
  if (props.size == "lg") {
    styles.height = "2.5rem";
    styles.lineHeight = "2.5rem";
    styles.padding = "8px";
    styles.paddingRight = "12px";
    styles.fontSize = "13px";
  } else {
    styles.height = "1.2rem";
    styles.lineHeight = "1rem";
    styles.padding = "4px";
    styles.paddingRight = "8px";
    styles.fontSize = "10px";
  }
  return styles;
});
const ProductSold = styled_es/* styled.div */.z.div(({ size }) => `
  color: #fff;
  margin-left: ${size === "sm" ? "4" : "8"}px;
  font-size: ${size === "sm" ? "8" : "10"}px;
  display: flex;
  align-items: center;
`);
const ProductSoldWrapper = styled_es/* styled.div */.z.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
`;
const FlashSaleBadge = ({
  sold,
  total,
  endAt,
  backgroundLinearGradient,
  backgroundColor,
  size = "sm",
  className,
  stock
}) => {
  const remain = Math.min(total - sold, stock || Number.MAX_SAFE_INTEGER);
  const message = sold / total > 0.9 || remain < 5 ? (0,i18n_es.t)("S\u1EAFp ch\xE1y h\xE0ng") : (0,i18n_es.t)("C\xF2n l\u1EA1i {{remain}}", { remain });
  const hidden = remain <= 0;
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(Wrapper, {
    className,
    backgroundLinearGradient,
    backgroundColor,
    size
  }, /* @__PURE__ */ react.createElement(ProductSoldWrapper, null, /* @__PURE__ */ react.createElement(FlashSaleFilled_es/* FlashSaleFilled */.R, {
    color: "#FFD591",
    size: size == "lg" ? 24 : 16
  }), /* @__PURE__ */ react.createElement(ProductSold, {
    size
  }, message)), endAt && /* @__PURE__ */ react.createElement(FlashSaleBadgeTime, {
    size,
    endAt
  }));
};




/***/ }),

/***/ 139676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ Specifications; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(666913);



const AttributeWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  &:nth-of-type(even) {
    background-color: #f6f6f6;
  }
`;
const Group = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 12px 16px;
  font-weight: 700;
  color: #848788;
  word-break: break-word;
`;
const Name = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  width: 40%;
  word-break: break-word;
  min-width: 40%;
`;
const Value = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  color: black;
  width: 60%;
  word-break: break-word;
`;
const Specifications = ({
  attributeGroups,
  isDiplayFullAttribute
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, attributeGroups.filter((att) => !!att.value || !att.value && att.parentId === 0).map((att, index) => {
    if (att.parentId === 0 && !isDiplayFullAttribute) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Group, {
        key: index
      }, att.name);
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AttributeWrapper, {
      key: index
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Name, null, att.name), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Value, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .HtmlRenderer */ .V, {
      content: att.value
    })));
  }));
};




/***/ }),

/***/ 129892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46610);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(912841);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var _Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(112288);
/* harmony import */ var _Text_Text_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(327513);
/* harmony import */ var _Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(528938);









var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, `
padding: 10px 16px;
display: flex;
justify-content: space-between;
align-items: center;
background: #fff;
`);
const Title = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_Text_Text_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x)`
  flex: 1;
  line-height: initial;
`;
const BlockHeader = (_a) => {
  var _b = _a, {
    title,
    onClick,
    hasDivider,
    children,
    targetPath,
    className,
    regionName,
    right
  } = _b, props = __objRest(_b, [
    "title",
    "onClick",
    "hasDivider",
    "children",
    "targetPath",
    "className",
    "regionName",
    "right"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    className
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, __spreadValues({
    marginRight: "8px",
    maxLines: 1
  }, title), children), onClick && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, __spreadValues({
    alignItems: "center"
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName,
    contentName: "viewAllProduct",
    target: regionName
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Text_Text_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, __spreadValues({
    color: "#848788",
    onClick
  }, right), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem t\u1EA5t c\u1EA3")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .SvgIcon */ .l, __spreadValues({
    name: "chevron-forward",
    size: 16,
    color: "#848788"
  }, right))), targetPath && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_8__/* .CustomLink */ .x, {
    targetPath
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Flex_Flex_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, __spreadValues({
    alignItems: "center"
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName,
    contentName: "viewAllProduct",
    target: regionName
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Text_Text_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, __spreadValues({
    color: "#848788"
  }, right), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem t\u1EA5t c\u1EA3")), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .SvgIcon */ .l, __spreadValues({
    name: "chevron-forward",
    size: 16,
    color: "#848788"
  }, right))))), hasDivider && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_9__/* .Divider */ .i, null));
};




/***/ }),

/***/ 679311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ProductShortDescriptionMobile; }
/* harmony export */ });
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(428247);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(708966);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(525369);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(334751);
/* harmony import */ var _Common_Article_Article_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(551165);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(129892);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const NoneDescription = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  padding: 1rem;
  color: #848788;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ShortDescription = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  background-color: #fff;
  border-radius: 0.5rem;
`;
const Content = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ maxHeight, expanded }) => `
  background-color: #fff;
  height: fit-content;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  ${expanded ? "" : `
  &:after {
    content: ' ';
    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    bottom: 0;
    height: 40px;
    width: 100%;
  };
  max-height: ${maxHeight}px;
  padding-bottom: 14px;
  `}
`);
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: relative;
`;
const ShowMore = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .ButtonChevron */ .y)`
  border-radius: 0;
  justify-content: center;
  padding: 14px 0;
  color: ${({ showArrow }) => showArrow ? "#848788" : "#0300BE"};
  width: calc(100% - 32px);
  margin-left: 16px;
  span {
    margin-left: 4px;
  }
`;
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.h2 */ .z.h2`
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
`;
const HEADER_HEIGHT = 72;
const HEADING_HEIGHT = 56;
const ProductShortDescriptionMobile = ({
  description,
  maxHeight,
  expandLabel = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Xem th\xEAm"),
  collapseLabel = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Thu g\u1ECDn"),
  moveTop = true,
  className,
  title = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("M\xF4 t\u1EA3 s\u1EA3n ph\u1EA9m"),
  isHideTitle = false
}) => {
  const [showMoreNeeded, setShowMoreNeeded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [expanded, setExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const descriptionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const handleClick = () => {
    setExpanded((prev) => {
      if (prev && moveTop && descriptionRef && descriptionRef.current) {
        const element = descriptionRef.current;
        window.scrollTo({
          left: 0,
          top: (0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .getElementOffset */ .pW)(element).top - HEADER_HEIGHT - HEADING_HEIGHT
        });
      }
      return !prev;
    });
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!descriptionRef.current)
      return;
    const ro = new ResizeObserver(() => {
      const el = descriptionRef.current;
      if (!el)
        return;
      !showMoreNeeded && setShowMoreNeeded(el.clientHeight < el.scrollHeight);
    });
    ro.observe(descriptionRef.current);
    return () => ro.disconnect();
  }, [showMoreNeeded]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ShortDescription, {
    className
  }, !isHideTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BlockHeader */ .t, {
    hasDivider: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, title)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, {
    ref: descriptionRef,
    maxHeight,
    expanded
  }, description ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_Article_Article_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Article */ .d, {
    content: description
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NoneDescription, null, isHideTitle ? "" : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("src.mobile.ProductDetail.ProductShortDescriptionMobile.0"))), showMoreNeeded && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "descriptionDetail",
    contentName: "viewMore",
    target: "productDescription"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ShowMore, {
    block: true,
    link: true,
    direction: expanded ? "up" : "down",
    onClick: handleClick,
    showArrow: !isHideTitle
  }, expanded ? collapseLabel : expandLabel))));
};




/***/ }),

/***/ 779436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ProductSpecificationsMobile; }
/* harmony export */ });
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(428247);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(708966);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(525369);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(334751);
/* harmony import */ var _ProductDetail_ProductSpecifications_Specifications_Specifications_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(139676);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(129892);








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  background-color: #fff;
  position: relative;
  border-radius: 8px;
`;
const Content = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ maxHeight, showMoreNeeded }) => `
  background-color: #fff;
  height: fit-content;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  ${showMoreNeeded ? "" : `
  &:after {
    content: ' ';
    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    bottom: 0;
    height: 40px;
    width: 100%;
  }
  max-height: ${maxHeight}px;
  padding-bottom: 14px;
  `}
`);
const ShowMore = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .ButtonChevron */ .y)`
  border-radius: 0;
  justify-content: center;
  padding: 14px 0;
  color: ${({ showArrow }) => showArrow ? "#848788" : "#0300BE"};
  width: calc(100% - 32px);
  margin-left: 16px;
  span {
    margin-left: 4px;
  }
`;
const HEADER_HEIGHT = 72;
const HEADING_HEIGHT = 56;
const ProductSpecificationsMobile = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, forwardedRef) => {
  var _b = _a, {
    attributeGroups,
    maxHeight,
    expandLabel = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Xem th\xEAm"),
    collapseLabel = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Thu g\u1ECDn"),
    className,
    moveTop = true,
    title = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Th\xF4ng s\u1ED1 k\u1EF9 thu\u1EADt"),
    isHideTitle = false,
    maxItemPerView
  } = _b, others = __objRest(_b, [
    "attributeGroups",
    "maxHeight",
    "expandLabel",
    "collapseLabel",
    "className",
    "moveTop",
    "title",
    "isHideTitle",
    "maxItemPerView"
  ]);
  const [showMoreNeeded, setShowMoreNeeded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const descriptionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [expanded, setExpanded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(forwardedRef, () => descriptionRef.current);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (descriptionRef && descriptionRef.current && !maxItemPerView) {
      const element = descriptionRef.current;
      setShowMoreNeeded(element.clientHeight < element.scrollHeight);
    }
  }, [descriptionRef]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!!maxItemPerView && (attributeGroups == null ? void 0 : attributeGroups.length) > maxItemPerView) {
      setShowMoreNeeded(true);
    }
  }, [maxItemPerView, attributeGroups]);
  const handleClick = () => {
    setExpanded((prev) => {
      if (prev && moveTop && descriptionRef && descriptionRef.current) {
        const element = descriptionRef.current;
        window.scrollTo({
          left: 0,
          top: (0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .getElementOffset */ .pW)(element).top - HEADER_HEIGHT - HEADING_HEIGHT
        });
      }
      return !prev;
    });
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    className
  }, others), !isHideTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BlockHeader */ .t, {
    title: {
      fontSize: 16,
      fontWeight: "500",
      paddingTop: 1
    },
    hasDivider: true
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, {
    ref: descriptionRef,
    maxHeight,
    showMoreNeeded: expanded
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductDetail_ProductSpecifications_Specifications_Specifications_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Specifications */ .G, {
    attributeGroups: !maxItemPerView ? attributeGroups : expanded ? attributeGroups : attributeGroups.slice(0, maxItemPerView),
    isDiplayFullAttribute: isHideTitle
  })), showMoreNeeded && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "specificationDetail",
    contentName: "viewMore",
    target: "productAttributeGroups"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ShowMore, {
    block: true,
    link: true,
    direction: expanded ? "up" : "down",
    onClick: handleClick,
    showArrow: !isHideTitle
  }, expanded ? collapseLabel : expandLabel))));
});
ProductSpecificationsMobile.displayName = "ProductSpecificationsMobile";




/***/ }),

/***/ 666913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ HtmlRenderer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const DefaultHtmlStyle = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 16px;
  }
  h4 {
    font-size: 14px;
  }
  h5 {
    font-size: 12px;
  }
  h6 {
    font-size: 10px;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;
const HtmlRenderer = ({
  content,
  className
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultHtmlStyle, {
  className,
  dangerouslySetInnerHTML: { __html: content }
});




/***/ }),

/***/ 530164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Countdown; },
  "m": function() { return /* binding */ calculateTimeDelta; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/hooks/useInterval.es.js
var useInterval_es = __webpack_require__(263661);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Countdown/DefaultCountdown.es.js



const Wrapper = styled_es/* default.div */.Z.div`
  display: flex;
`;
const sizeMaps = {
  sm: "24px",
  md: "45px",
  lg: "55px"
};
const fontSizeMaps = {
  sm: "12px",
  md: "20px",
  lg: "24px"
};
const Segment = styled_es/* default.div */.Z.div(({ size }) => `
  width: ${sizeMaps[size]};
  height: ${sizeMaps[size]};
  border-radius: 4px;
  background-image: linear-gradient(to bottom, #4a4a4a, #232222);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${fontSizeMaps[size]};
  font-weight: 700;
  overflow: hidden;
`);
const NumberFrame = styled_es/* default.div */.Z.div`
  height: 45px;
  display: flex;
  align-items: center;
`;
const spacerSizeMap = {
  sm: "0.2rem",
  md: "0.5rem",
  lg: "0.8rem"
};
const Spacer = styled_es/* default.div */.Z.div(({ size }) => `
  width: ${spacerSizeMap[size]};
`);
const extractParts = (number) => {
  const out = number.toString().padStart(2, "0");
  return [Number(out[0]), Number(out[1])];
};
const DefaultCountdown = ({ duration, size }) => {
  const [sec1, sec2] = (0,react.useMemo)(() => extractParts(duration.seconds), [duration.seconds]);
  const [min1, min2] = (0,react.useMemo)(() => extractParts(duration.minutes), [duration.minutes]);
  const [hour1, hour2] = (0,react.useMemo)(() => extractParts(duration.hours), [duration.hours]);
  return /* @__PURE__ */ react.createElement(Wrapper, null, /* @__PURE__ */ react.createElement(Segment, {
    size
  }, /* @__PURE__ */ react.createElement(NumberFrame, null, hour1), /* @__PURE__ */ react.createElement(NumberFrame, null, hour2)), /* @__PURE__ */ react.createElement(Spacer, {
    size
  }), /* @__PURE__ */ react.createElement(Segment, {
    size
  }, /* @__PURE__ */ react.createElement(NumberFrame, null, min1), /* @__PURE__ */ react.createElement(NumberFrame, null, min2)), /* @__PURE__ */ react.createElement(Spacer, {
    size
  }), /* @__PURE__ */ react.createElement(Segment, {
    size
  }, /* @__PURE__ */ react.createElement(NumberFrame, null, sec1), /* @__PURE__ */ react.createElement(NumberFrame, null, sec2)));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Countdown/Countdown.es.js




const calculateTimeDelta = (date) => {
  let startTimestamp;
  if (typeof date === "string") {
    startTimestamp = new Date(date).getTime();
  } else if (date instanceof Date) {
    startTimestamp = date.getTime();
  } else {
    startTimestamp = date;
  }
  const durationInMs = Math.round(parseFloat((Math.max(0, startTimestamp - Date.now()) / 1e3).toFixed(0)) * 1e3);
  const durationInSecond = durationInMs / 1e3;
  return {
    durationInMs,
    days: Math.floor(durationInSecond / (3600 * 24)),
    hours: Math.floor(durationInSecond / 3600 % 24),
    minutes: Math.floor(durationInSecond / 60 % 60),
    seconds: Math.floor(durationInSecond % 60)
  };
};
const DefaultRenderer = (duration, size = "md") => /* @__PURE__ */ react.createElement(DefaultCountdown, {
  duration,
  size
});
const Countdown = ({
  date,
  renderer = DefaultRenderer,
  className,
  size = "md"
}) => {
  const [duration, setDuration] = (0,react.useState)(calculateTimeDelta(date));
  (0,useInterval_es/* useInterval */.Y)(() => {
    setDuration(calculateTimeDelta(date));
  }, 1e3, duration.durationInMs === 0);
  return /* @__PURE__ */ react.createElement("div", {
    className
  }, renderer && renderer(duration, size));
};




/***/ }),

/***/ 942541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ CountdownText; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _hooks_useInterval_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(263661);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _Countdown_Countdown_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(530164);





const addPaddingNumber = (number) => number.toString().padStart(2, "0");
const daysString = (days) => days === 0 ? `` : `${days} ng\xE0y`;
const BoldWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  font-weight: bold;
`;
const CountdownText = ({
  date,
  className
}) => {
  const [duration, setDuration] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_Countdown_Countdown_es_js__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeDelta */ .m)(date));
  (0,_hooks_useInterval_es_js__WEBPACK_IMPORTED_MODULE_3__/* .useInterval */ .Y)(() => {
    setDuration((0,_Countdown_Countdown_es_js__WEBPACK_IMPORTED_MODULE_2__/* .calculateTimeDelta */ .m)(date));
  }, 1e3, duration.durationInMs === 0);
  const message = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (daysString(duration.days) !== ``) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, "C\xF2n ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BoldWrapper, null, daysString(duration.days)));
    } else {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, "C\xF2n ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BoldWrapper, null, addPaddingNumber(duration.hours), ":", addPaddingNumber(duration.minutes), ":", addPaddingNumber(duration.seconds)));
    }
  }, [duration]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className
  }, message);
};




/***/ }),

/***/ 263661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useInterval; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const useInterval = (callback, delay, completed) => {
  const savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    savedCallback.current = callback;
  }, [callback]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const handler = (...args) => {
      if (savedCallback && savedCallback.current) {
        savedCallback.current(...args);
      }
    };
    if (delay !== null && !completed) {
      const id = setInterval(handler, delay);
      return () => clearInterval(id);
    }
  }, [delay, completed]);
};




/***/ })

}]);